import { render, staticRenderFns } from "./CommentComponent.vue?vue&type=template&id=d14f3f84&scoped=true"
import script from "./CommentComponent.vue?vue&type=script&lang=js"
export * from "./CommentComponent.vue?vue&type=script&lang=js"
import style0 from "./CommentComponent.vue?vue&type=style&index=0&id=d14f3f84&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d14f3f84",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d14f3f84')) {
      api.createRecord('d14f3f84', component.options)
    } else {
      api.reload('d14f3f84', component.options)
    }
    module.hot.accept("./CommentComponent.vue?vue&type=template&id=d14f3f84&scoped=true", function () {
      api.rerender('d14f3f84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/comment/CommentComponent.vue"
export default component.exports